import React from "react";
import { Helmet } from "react-helmet";
import DashboardLayout from "@/components/DashboardLayout";
import EnterpriseHero from "@/components/enterprise/EnterpriseHero";
import EnterpriseFeaturesGrid from "@/components/enterprise/EnterpriseFeaturesGrid";
import EnterpriseBlueprint from "@/components/enterprise/EnterpriseBlueprint";
import EnterpriseResults from "@/components/enterprise/EnterpriseResults";
import EnterpriseTestimonials from "@/components/enterprise/EnterpriseTestimonials";
import EnterpriseCaseStudies from "@/components/enterprise/EnterpriseCaseStudies";
import PageCallToAction from "@/components/PageCallToAction";

const Enterprise = () => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>Enterprise Solutions | OpenPipe</title>
        <meta
          name="description"
          content="Modern LLM‑powered agents can unlock exponential value, but only when they are meticulously aligned with your corporate objectives."
        />
      </Helmet>
      <div className="max-w-6xl mx-auto space-y-5">
        <EnterpriseHero />

        <section className="pt-4">
          <div className="max-w-4xl mx-auto text-center px-6">
            <h2 className="text-3xl font-bold mb-6">
              Why Leading Enterprises Trust Us
            </h2>
            <p className="text-lg text-muted-foreground">
              Modern LLM‑powered agents can unlock exponential value, but only
              when they are meticulously aligned with your corporate objectives.
              Our engagements combine deep RL research pedigree with proven
              change‑management playbooks to turn raw autonomy into strategic
              advantage.
            </p>
          </div>
        </section>
        <EnterpriseFeaturesGrid />
        <EnterpriseBlueprint />
        <PageCallToAction />
      </div>
    </DashboardLayout>
  );
};

export default Enterprise;
